export	const PLATFORM_HELP_DATA = [
    {
        id: "que_ingresar",
        textButton: {
            default: "¿Qué ves al ingresar?",
            translationPath: "platform.que_ingresar.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1124879020?h=44a4c9db67&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "platform.que_ingresar.url",
        },
    },
    {
        id: "como_busco",
        textButton: {
            default: "¿Cómo realizar búsquedas?",
            translationPath: "platform.como_busco.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1124878971?h=b9b37cf935&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "platform.como_busco.url",
        },
    },
    {
        id: "curadurias",
        textButton: {
            default: "Listas de lectura",
            translationPath: "platform.curadurias.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1124878993?h=029aa2e94a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "platform.curadurias.url",
        },
    },
    {
        id: "descubre",
        textButton: {
            default: "Guías de lectura",
            translationPath: "platform.descubre.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1015730285?h=921bafb537",
            translationPath: "platform.descubre.url",
        },
    },
    {
        id: "club",
        textButton: {
            default: "Club MakeMake",
            translationPath: "platform.club.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1001683932?h=0acfbdb9c9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "platform.club.url",
        },
    },
    {
        id: "recursos",
        textButton: {
            default: "Centro de recursos",
            translationPath: "platform.recursos.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1124879043?h=4d2d5458fb&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "platform.recursos.url",
        },
    },
    {
        id: "blog",
        textButton: {
            default: "MakeBlog",
            translationPath: "platform.blog.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1001684150?h=1d3abc5ff0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "platform.blog.url",
        },
    },
    {
        id: "notificaciones",
        textButton: {
            default: "Notificaciones",
            translationPath: "platform.notificaciones.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1001684177?h=88d3292100&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "platform.notificaciones.url",
        },
    },
]